import React from 'react';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ModalTittle from './assets/ModalTittle';
import ModalAction from './assets/ModalAction';
import ModalContent from './assets/ModalContent';

const MovaticCustomModal = ({
  dataId = 'movatic-custom-modal',
  open,
  onClose,
  content,
  title,
  action,
  customStyles = {},
  sx = {},
  useContentDividers = false,
  isLoading = false,
}) => {
  const defaultStyle = {
    title: {
      // color: `${MOVATIC_PRIMARY_COLOR(1)}`,
      fontWeight: '600',
      ...customStyles?.title,
    },
    action: {
      //padding: '1.6rem',
    },
  };
  return (
    <Dialog sx={sx} open={open} onClose={isLoading ? undefined : onClose} id={`${dataId}`}>
      <ModalTittle customStyle={defaultStyle.title} onClose={isLoading ? undefined : onClose}>
        {title}
      </ModalTittle>
      <ModalContent
        useDividers={useContentDividers}
        customStyle={customStyles?.content || { minWidth: '30rem' }}
        dividers
      >
        <Box sx={{ position: 'relative' }}>
          {isLoading && (
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 1,
              }}
            >
              <CircularProgress />
            </Box>
          )}
          {content}
        </Box>
      </ModalContent>
      {action && (
        <ModalAction customStyle={customStyles?.action || defaultStyle.action}>
          <Box sx={{ position: 'relative' }}>
            {isLoading && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.7)',
                  zIndex: 1,
                }}
              />
            )}
            {action}
          </Box>
        </ModalAction>
      )}
    </Dialog>
  );
};

export default MovaticCustomModal;
